<modal-container [breadcrumbsList]="breadcrumbsList" [hideSaveButton]="true">
  <div class="diagnostic-container">
    <div class="header-section">
      <h3>System Health</h3>
      <p>Verifica lo stato di integrit&agrave; del sistema</p>
    </div>

    <div class="diagnostic-scope" [class.is-global]="diagnosticScope.type === 'global'"
      [attr.title]="diagnosticScope.description"
      [attr.aria-label]="'Ambito diagnostica: ' + diagnosticScope.label">
      <div class="scope-content">
        <span class="scope-kicker">Ambito</span>
        <strong>{{ diagnosticScope.label }}</strong>
      </div>
    </div>

    @if (status === 'idle') {
      <div class="start-container">
        <button type="button" class="soft-circle-btn giant" (click)="startDiagnostic()" aria-label="Avvia diagnostica">
          <ion-icon name="pulse-outline"></ion-icon>
        </button>
        <p class="hint-text">Tocca per avviare la scansione completa</p>
      </div>
    }

    @if (status !== 'idle') {
      <div class="steps-list">
        @for (step of diagnosticSteps; track step.id) {
          <div class="soft-card step-card"
            [class.active]="step.state === 'running'"
            [class.warning]="step.state === 'warning'"
            [class.error]="step.state === 'error'"
            [class.success]="step.state === 'success'">
            <div class="step-header">
              <div class="icon-box">
                @if (step.state === 'pending') { <ion-icon name="ellipse-outline" class="pale"></ion-icon> }
                @if (step.state === 'running') { <ion-spinner name="crescent" color="primary"></ion-spinner> }
                @if (step.state === 'success') { <ion-icon name="checkmark-circle" color="success"></ion-icon> }
                @if (step.state === 'warning') { <ion-icon name="warning-outline" color="warning"></ion-icon> }
                @if (step.state === 'error') { <ion-icon name="alert-circle" color="danger"></ion-icon> }
              </div>
              <div class="step-info">
                <span class="step-name">{{ step.label }}</span>
                <span class="step-status">
                  @switch (step.state) {
                    @case ('pending') { In attesa... }
                    @case ('running') { Analisi in corso... }
                    @case ('success') { OK }
                    @case ('warning') { Attenzione }
                    @case ('error') { Rilevati problemi }
                  }
                </span>
              </div>
              @if (step.issues.length > 0) {
                <button type="button" class="accordion-toggle" [class.expanded]="step.expanded"
                  [attr.aria-expanded]="step.expanded"
                  [attr.aria-label]="(step.expanded ? 'Chiudi ' : 'Apri ') + step.label"
                  (click)="toggleStep(step)">
                  <ion-icon name="chevron-down-outline"></ion-icon>
                </button>
              }
            </div>

            @if (step.expanded && step.issues.length > 0) {
              <div class="issues-container">
                @for (issue of step.issues; track $index) {
                  <div class="issue-card" [class.is-warning]="issue.severity === 'warning'" [class.is-error]="issue.severity === 'error'">
                    <div class="issue-content">
                      <ion-icon [name]="issue.severity === 'error' ? 'alert-circle' : 'warning-outline'" class="icon-indicator"></ion-icon>
                      <span class="issue-text">{{ issue.message }}</span>
                    </div>
                    @if (issue.redirectTo) {
                      <ion-button size="small" fill="clear" [color]="issue.severity === 'warning' ? 'warning' : 'danger'"
                        (click)="navigateDetails(issue.redirectTo, issue.params)">
                        Vedi
                      </ion-button>
                    }
                  </div>
                }
              </div>
            }
          </div>
        }

        @if (diagnosticsState === 'pending') {
          <div class="soft-card step-card">
            <div class="step-header">
              <div class="icon-box"><ion-icon name="ellipse-outline" class="pale"></ion-icon></div>
              <div class="step-info">
                <span class="step-name">Diagnostica sensori</span>
                <span class="step-status">In attesa...</span>
              </div>
            </div>
          </div>
        }

        @if (diagnosticsState === 'running') {
          <div class="soft-card step-card active">
            <div class="step-header">
              <div class="icon-box"><ion-spinner name="crescent" color="primary"></ion-spinner></div>
              <div class="step-info">
                <span class="step-name">Diagnostica sensori</span>
                <span class="step-status">Recupero metriche in corso...</span>
              </div>
            </div>
          </div>
        }

        @if (diagnosticsState === 'error') {
          <div class="soft-card step-card error diagnostics-error-card">
            <div class="step-header">
              <div class="icon-box"><ion-icon name="alert-circle" color="danger"></ion-icon></div>
              <div class="step-info">
                <span class="step-name">Diagnostica sensori</span>
                <span class="step-status">{{ diagnosticsError }}</span>
              </div>
              <ion-button size="small" fill="clear" color="danger" (click)="retryDeviceDiagnostics()">
                <ion-icon name="refresh-outline" slot="start"></ion-icon>
                Riprova
              </ion-button>
            </div>
          </div>
        }

        @if (diagnosticsState === 'success' && diagnosticChecks.length === 0) {
          <div class="soft-card step-card success">
            <div class="step-header">
              <div class="icon-box"><ion-icon name="checkmark-circle" color="success"></ion-icon></div>
              <div class="step-info">
                <span class="step-name">Diagnostica sensori</span>
                <span class="step-status">OK</span>
              </div>
            </div>
          </div>
        }

        @for (metric of diagnosticChecks; track metric.check.key) {
          <div class="soft-card step-card metric-step-card"
            [class.active]="metric.state === 'running'"
            [class.warning]="metric.state === 'warning'"
            [class.error]="metric.state === 'error'"
            [class.success]="metric.state === 'success'">
            <div class="step-header">
              <div class="icon-box">
                @if (metric.state === 'pending') { <ion-icon name="ellipse-outline" class="pale"></ion-icon> }
                @if (metric.state === 'running') { <ion-spinner name="crescent" color="primary"></ion-spinner> }
                @if (metric.state === 'success') { <ion-icon name="checkmark-circle" color="success"></ion-icon> }
                @if (metric.state === 'warning') { <ion-icon name="warning-outline" color="warning"></ion-icon> }
                @if (metric.state === 'error') { <ion-icon name="alert-circle" color="danger"></ion-icon> }
              </div>
              <div class="step-info">
                <span class="step-name">{{ getCheckTitle(metric.check) }}</span>
                <span class="step-status">
                  @switch (metric.state) {
                    @case ('pending') { In attesa... }
                    @case ('running') { Analisi in corso... }
                    @case ('success') { OK }
                    @case ('warning') { Attenzione }
                    @case ('error') { Rilevati problemi }
                  }
                </span>
              </div>
              @if (metric.state !== 'pending' && metric.state !== 'running' && metric.check.alerts.length > 0) {
                <button type="button" class="accordion-toggle" [class.expanded]="metric.expanded"
                  [attr.aria-expanded]="metric.expanded"
                  [attr.aria-label]="(metric.expanded ? 'Chiudi ' : 'Apri ') + getCheckTitle(metric.check)"
                  (click)="toggleMetric(metric)">
                  <ion-icon name="chevron-down-outline"></ion-icon>
                </button>
              }
            </div>

            @if (metric.expanded && metric.state !== 'pending' && metric.state !== 'running' && metric.check.alerts.length > 0) {
              <div class="issues-container">
                @for (alert of metric.check.alerts; track alert.id) {
                  <div class="issue-card" [class.is-warning]="alert.severity === 'warning'" [class.is-error]="alert.severity === 'error'">
                    <div class="issue-content">
                      <ion-icon [name]="alert.severity === 'error' ? 'alert-circle' : 'warning-outline'" class="icon-indicator"></ion-icon>
                      <span class="issue-text">{{ getAlertMessage(metric.check, alert) }}</span>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    }

    @if (status === 'finished') {
      <div class="footer-actions">
        <button type="button" class="soft-save-btn" (click)="reset()">Nuova scansione</button>
      </div>
    }
  </div>
</modal-container>
